export const REDUCER_NAME = "orderReportSlice";

// ✅ Generic API response
export interface iGenericResponse<T = any> {
  success?: boolean;
  message: string;
  data?: T;
}

// ✅ Common loading/error/message state
export interface iStateMessage {
  loading: boolean;
  loadingList: boolean;
  error: string | null;
  message: string | null;
}

// ✅ Example additional interface
export interface iAddProFormInvoiceDetail {
  inspection: string;
  insurance: string;
  freightTransportation: string;
}

// ✅ Define product type
export interface iOrderProduct {
  title: string;
  description: string;
  productType: string;
  sku: string;
  image: string;
  [key: string]: any; // for any additional fields
}

// ✅ Monthly chart data type
export interface iMonthlyData {
  month: string;
  revenue: number;
  profit: number;
}

// ✅ Order report data from API
export interface iOrderReportData {
  cancelled: number;
  completed: number;
  ongoing: number;
  monthlyData: iMonthlyData[];
  products: iOrderProduct[];
  totalOrders: number;
}

// ✅ Strongly typed Redux slice state
export interface ProFormaInvoce extends iStateMessage {
  productDetail: any | null;
  loadingDataList: boolean;
  dataList: iOrderReportData | null;
}
